import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftAddon,
  Text,
} from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

type Props = {
  id: string;
  label: string;
  isRequired?: boolean;
  leftText?: string;
};

function FormTextInput({ label, id, isRequired, leftText }: Props) {
  const { formState, register, setValue } = useFormContext();
  const { errors }: { errors: any } = formState;

  return (
    <FormControl id={id} isRequired={isRequired} mb={2}>
      <FormLabel>{label}</FormLabel>
      {errors[id] && (
        <Text color="red.500" fontStyle="italic">
          {errors[id]?.message}
        </Text>
      )}
      <InputGroup>
        {leftText && <InputLeftAddon>{leftText}</InputLeftAddon>}
        <Input
          fontSize="md"
          isInvalid={!!errors[id]}
          {...register(id)}
          onChange={(e) => {
            if (leftText) {
              const pasteText = e.target.value;

              if (pasteText) {
                const trimmedValue = pasteText.replace(leftText, '');

                setValue(id, trimmedValue);
              }
            }
          }}
        />
      </InputGroup>
    </FormControl>
  );
}

export default FormTextInput;
